import React from 'react';

interface Props {
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const TableIcon: React.FC<Props> = ({ className, onClick }) => (
  <svg className={className} onClick={onClick} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.2654 1.33398H2.73203C1.73203 1.33398 1.33203 1.76065 1.33203 2.82065V13C1.33203 14.06 1.73203 14.5 2.73203 14.5H13.2654C14.2654 14.5 14.6654 14.06 14.6654 13C14.6654 11.94 14.6654 2.82065 14.6654 2.82065C14.6654 2.82065 14.6654 2.82065 14.6654 2.82065C14.6654 1.76065 14.2654 1.33398 13.2654 1.33398Z"
      stroke="#292D32"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 5.5H14" stroke="#292D32" strokeWidth="1" />
    <path d="M6 2L6 14" stroke="#292D32" strokeWidth="1" />
    <path d="M2 10H14" stroke="#292D32" strokeWidth="1" />
  </svg>
);

export const table = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.5 7.5L17.5 7.5M7.5 2.5L7.5 17.5M6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TableIcon;
